<div class="page-shell">
  <mat-toolbar class="header">
    <span>{{ "digitalCards.domainStatistics" | translate }}: {{ totalRows }}</span>
    <div class="actions">
      <button
        mat-stroked-button
        type="button"
        (click)="loadData('full')"
        [disabled]="tableLoading || summaryLoading"
      >
        <mat-icon>refresh</mat-icon>
        {{ "cardOrders.refresh" | translate }}
      </button>
      <button mat-stroked-button type="button" (click)="exportCsv()">
        <mat-icon>download</mat-icon>
        {{ "digitalCards.stats.exportCsv" | translate }}
      </button>
    </div>
  </mat-toolbar>

  <div class="stats-wrapper">
    <form class="filters-row">
      <mat-form-field class="search-field" appearance="outline" subscriptSizing="dynamic">
        <input
          matInput
          [formControl]="searchControl"
          [placeholder]="'digitalCards.stats.searchPlaceholder' | translate"
          [attr.aria-label]="'auditLog.search' | translate"
        />
        <mat-icon matPrefix>search</mat-icon>
      </mat-form-field>
      <app-range-calendar
        [label]="'digitalCards.stats.filterByDate' | translate"
        [dateRangeForm]="dateRangeForm"
      ></app-range-calendar>
    </form>

    <div class="dc-stats-summary">
      <div class="dc-stats-summary__card">
        <div class="dc-stats-summary__loader" *ngIf="summaryLoading">
          <app-loading [hideText]="true"></app-loading>
        </div>
        <ng-container *ngIf="!summaryLoading">
          <div class="dc-stats-summary__body">
            <span class="dc-stats-summary__value">{{
              overviewVisits | number
            }}</span>
            <span class="dc-stats-summary__label">{{
              "digitalCards.stats.landings" | translate
            }}</span>
            <span class="dc-stats-summary__hint">{{
              "digitalCards.stats.landingsHint" | translate
            }}</span>
          </div>
        </ng-container>
      </div>
      <div class="dc-stats-summary__card">
        <div class="dc-stats-summary__loader" *ngIf="summaryLoading">
          <app-loading [hideText]="true"></app-loading>
        </div>
        <ng-container *ngIf="!summaryLoading">
          <div class="dc-stats-summary__body">
            <span class="dc-stats-summary__value">{{
              overviewSourceHits | number
            }}</span>
            <span class="dc-stats-summary__label">{{
              "digitalCards.stats.sourceHits" | translate
            }}</span>
            <span class="dc-stats-summary__hint">{{
              "digitalCards.stats.sourceHitsHint" | translate
            }}</span>
          </div>
        </ng-container>
      </div>
      <div class="dc-stats-summary__card">
        <div class="dc-stats-summary__loader" *ngIf="summaryLoading">
          <app-loading [hideText]="true"></app-loading>
        </div>
        <ng-container *ngIf="!summaryLoading">
          <div class="dc-stats-summary__body">
            <span class="dc-stats-summary__value">{{
              overviewInteractions | number
            }}</span>
            <span class="dc-stats-summary__label">{{
              "digitalCards.stats.interactions" | translate
            }}</span>
            <span class="dc-stats-summary__hint">{{
              "digitalCards.stats.interactionsHint" | translate
            }}</span>
          </div>
        </ng-container>
      </div>
      <div class="dc-stats-summary__card">
        <div class="dc-stats-summary__loader" *ngIf="summaryLoading">
          <app-loading [hideText]="true"></app-loading>
        </div>
        <ng-container *ngIf="!summaryLoading">
          <div class="dc-stats-summary__body">
            <span class="dc-stats-summary__value">{{ overviewCards | number }}</span>
            <span class="dc-stats-summary__label">{{
              "digitalCards.stats.cardsAnalyzed" | translate
            }}</span>
            <span class="dc-stats-summary__hint">{{
              "digitalCards.stats.cardsAnalyzedHint" | translate
            }}</span>
          </div>
        </ng-container>
      </div>
      <div class="dc-stats-summary__card">
        <div class="dc-stats-summary__loader" *ngIf="summaryLoading">
          <app-loading [hideText]="true"></app-loading>
        </div>
        <ng-container *ngIf="!summaryLoading">
          <div class="dc-stats-summary__body">
            <span class="dc-stats-summary__value">{{ overviewContacts | number }}</span>
            <span class="dc-stats-summary__label">{{
              "digitalCards.stats.contactsColumn" | translate
            }}</span>
            <span class="dc-stats-summary__hint">{{
              "digitalCards.stats.savedContactsNote" | translate
            }}</span>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="domain-overview" *ngIf="showDomainOverview">
      <section class="detail-panel detail-panel--overview">
        <div class="dc-stats-summary__loader" *ngIf="summaryLoading">
          <app-loading [hideText]="true"></app-loading>
        </div>
        <ng-container *ngIf="!summaryLoading">
          <header class="detail-panel__header">
            <h3>{{ "digitalCards.stats.domainSourcesTitle" | translate }}</h3>
            <span class="detail-panel__total">{{
              overviewSourceHits | number
            }}</span>
          </header>
          <p class="detail-panel__highlight" *ngIf="overviewTopSource">
            {{ "digitalCards.stats.topSource" | translate }}:
            <strong>{{ overviewTopSource.label }}</strong>
            ({{ overviewTopSource.count | number }})
          </p>
          <p class="detail-panel__empty" *ngIf="!overviewSources.length">
            {{ "digitalCards.stats.noSources" | translate }}
          </p>
          <ul class="detail-list" *ngIf="overviewSources.length">
            <li *ngFor="let item of overviewSources">
              <div class="detail-list__meta">
                <span class="detail-list__label">{{ item.label }}</span>
                <span
                  class="detail-list__kind"
                  [class.detail-list__kind--campaign]="item.kind === 'campaign'"
                >
                  {{
                    (item.kind === "campaign"
                      ? "digitalCards.stats.contextCampaign"
                      : "digitalCards.stats.contextShare"
                    ) | translate
                  }}
                </span>
              </div>
              <div class="detail-list__bar" aria-hidden="true">
                <span [style.width.%]="item.pct"></span>
              </div>
              <span class="detail-list__count">
                <strong>{{ item.count | number }}</strong>
                <small>{{ item.pct }}%</small>
                <small *ngIf="overviewVisits" class="detail-list__of-visits">
                  {{ item.ofVisitsPct }}%
                  {{ "digitalCards.stats.ofVisits" | translate }}
                </small>
              </span>
            </li>
          </ul>
        </ng-container>
      </section>

      <section class="detail-panel detail-panel--overview">
        <div class="dc-stats-summary__loader" *ngIf="summaryLoading">
          <app-loading [hideText]="true"></app-loading>
        </div>
        <ng-container *ngIf="!summaryLoading">
          <header class="detail-panel__header">
            <h3>{{ "digitalCards.stats.domainClicksTitle" | translate }}</h3>
            <span class="detail-panel__total">{{
              overviewInteractions | number
            }}</span>
          </header>
          <p class="detail-panel__highlight" *ngIf="overviewTopClick">
            {{ "digitalCards.stats.topElement" | translate }}:
            <strong>{{ overviewTopClick.label }}</strong>
            ({{ overviewTopClick.count | number }})
          </p>
          <p
            class="detail-panel__rates"
            *ngIf="overviewVisits && overviewInteractions"
          >
            <span>
              {{ overviewInteractionRate }}%
              {{ "digitalCards.stats.ofVisits" | translate }}
              ·
              {{ "digitalCards.stats.interactionsColumn" | translate }}
            </span>
          </p>
          <p class="detail-panel__empty" *ngIf="!overviewClicks.length">
            {{ "digitalCards.stats.noClicks" | translate }}
          </p>
          <ul class="detail-list" *ngIf="overviewClicks.length">
            <li *ngFor="let item of overviewClicks">
              <div class="detail-list__meta">
                <span class="detail-list__label">{{ item.label }}</span>
                <span class="detail-list__kind">{{
                  "digitalCards.stats.contextClick" | translate
                }}</span>
              </div>
              <div class="detail-list__bar" aria-hidden="true">
                <span [style.width.%]="item.pct"></span>
              </div>
              <span class="detail-list__count">
                <strong>{{ item.count | number }}</strong>
                <small>{{ item.pct }}%</small>
                <small *ngIf="overviewVisits" class="detail-list__of-visits">
                  {{ item.ofVisitsPct }}%
                  {{ "digitalCards.stats.ofVisits" | translate }}
                </small>
              </span>
            </li>
          </ul>
        </ng-container>
      </section>
    </div>

    <div
      class="table-container stats-table-container"
      [class.table-container--empty]="isEmpty || showNoSearchResults"
      [class.table-container--loading]="tableLoading"
    >
      <table
        mat-table
        [dataSource]="tableRows"
        matSort
        multiTemplateDataRows
        [matSortActive]="sortBy"
        [matSortDirection]="sortDirection"
        (matSortChange)="onSortChange($event)"
        class="stats-table mat-elevation-z0"
      >
        <ng-container matColumnDef="expand">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <button
              mat-icon-button
              type="button"
              class="expand-btn"
              [disabled]="!row.hasDetails"
              [attr.aria-expanded]="row.isExpanded"
              [attr.aria-label]="'digitalCards.stats.expandRow' | translate"
              (click)="toggleRow(row, $event)"
            >
              <mat-icon>{{
                row.isExpanded ? "expand_less" : "expand_more"
              }}</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="employee">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="employee">
            {{ "digitalCards.stats.employeeEmail" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <button
              type="button"
              class="employee-cell"
              [disabled]="!row.hasDetails"
              (click)="toggleRow(row, $event)"
            >
              <span class="employee-cell__email">{{ row.employee }}</span>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="cardName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="cardName">
            {{ "digitalCards.displayName" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <span class="card-name">{{ row.cardName }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="visits">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="visits">
            {{ "digitalCards.stats.employeeVisits" | translate }}
          </th>
          <td mat-cell *matCellDef="let row" class="cell-num">
            {{ row.visits | number }}
          </td>
        </ng-container>

        <ng-container matColumnDef="sources">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="sources">
            {{ "digitalCards.stats.sourcesColumn" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="metric-cell">
              <span class="metric-cell__value">{{ row.sourcesTotal | number }}</span>
              <span class="metric-cell__preview" *ngIf="row.topSources.length">
                {{ row.topSources[0].label
                }}<ng-container *ngIf="row.topSources.length > 1"
                  >, {{ row.topSources[1].label }}</ng-container
                >
              </span>
              <span class="metric-cell__empty" *ngIf="!row.topSources.length">—</span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="interactions">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="interactions">
            {{ "digitalCards.stats.interactionsColumn" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="metric-cell">
              <span class="metric-cell__value">{{
                row.interactionsTotal | number
              }}</span>
              <span
                class="metric-cell__preview"
                *ngIf="row.clickBreakdown.length"
              >
                {{ row.clickBreakdown[0].label }}
              </span>
              <span
                class="metric-cell__empty"
                *ngIf="!row.clickBreakdown.length"
                >—</span
              >
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="contacts">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="contacts">
            {{ "digitalCards.stats.contactsColumn" | translate }}
          </th>
          <td mat-cell *matCellDef="let row" class="cell-num">
            {{ row.savedContactForms | number }}
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td
            mat-cell
            *matCellDef="let row"
            class="expanded-detail-cell"
            [attr.colspan]="displayedColumns.length"
          >
            <div
              class="expanded-detail"
              *ngIf="row.isExpanded"
              (click)="$event.stopPropagation()"
            >
              <div class="detail-identity">
                <div class="detail-identity__main">
                  <span class="detail-identity__email">{{ row.employee }}</span>
                  <span class="detail-identity__card">
                    <span class="detail-identity__card-label">{{
                      "digitalCards.displayName" | translate
                    }}</span>
                    <strong>{{ row.cardName }}</strong>
                  </span>
                </div>
                <div class="detail-identity__highlights">
                  <span *ngIf="row.topSource">
                    {{ "digitalCards.stats.topSource" | translate }}:
                    <strong>{{ row.topSource.label }}</strong>
                    ({{ row.topSource.count | number }})
                  </span>
                  <span *ngIf="row.topClick">
                    {{ "digitalCards.stats.topElement" | translate }}:
                    <strong>{{ row.topClick.label }}</strong>
                    ({{ row.topClick.count | number }})
                  </span>
                </div>
              </div>

              <div class="detail-kpis">
                <div class="detail-kpi">
                  <span class="detail-kpi__value">{{ row.visits | number }}</span>
                  <span class="detail-kpi__label">{{
                    "digitalCards.stats.landings" | translate
                  }}</span>
                </div>
                <div class="detail-kpi">
                  <span class="detail-kpi__value">{{
                    row.sourcesTotal | number
                  }}</span>
                  <span class="detail-kpi__label">{{
                    "digitalCards.stats.sourcesColumn" | translate
                  }}</span>
                  <span class="detail-kpi__sub" *ngIf="row.sourcesTotal">
                    {{ row.channelSourcesTotal | number }}
                    {{ "digitalCards.stats.contextShare" | translate }}
                    ·
                    {{ row.campaignSourcesTotal | number }}
                    {{ "digitalCards.stats.contextCampaign" | translate }}
                  </span>
                </div>
                <div class="detail-kpi">
                  <span class="detail-kpi__value">{{
                    row.interactionsTotal | number
                  }}</span>
                  <span class="detail-kpi__label">{{
                    "digitalCards.stats.interactionsColumn" | translate
                  }}</span>
                  <span class="detail-kpi__sub" *ngIf="row.visits">
                    {{ row.interactionRate }}%
                    {{ "digitalCards.stats.ofVisits" | translate }}
                  </span>
                </div>
                <div class="detail-kpi">
                  <span class="detail-kpi__value">{{
                    row.savedContactForms | number
                  }}</span>
                  <span class="detail-kpi__label">{{
                    "digitalCards.stats.savedContactsNote" | translate
                  }}</span>
                  <span class="detail-kpi__sub" *ngIf="row.visits">
                    {{ row.contactRate }}%
                    {{ "digitalCards.stats.ofVisits" | translate }}
                  </span>
                </div>
              </div>

              <div class="detail-grid">
                <section class="detail-panel">
                  <header class="detail-panel__header">
                    <h3>{{ "digitalCards.stats.bySource" | translate }}</h3>
                    <span class="detail-panel__total">{{
                      row.sourcesTotal | number
                    }}</span>
                  </header>
                  <p class="detail-panel__empty" *ngIf="!row.sourceBreakdown.length">
                    {{ "digitalCards.stats.noSources" | translate }}
                  </p>
                  <ul class="detail-list" *ngIf="row.sourceBreakdown.length">
                    <li *ngFor="let item of row.sourceBreakdown">
                      <div class="detail-list__meta">
                        <span class="detail-list__label">{{ item.label }}</span>
                        <span
                          class="detail-list__kind"
                          [class.detail-list__kind--campaign]="
                            item.kind === 'campaign'
                          "
                        >
                          {{
                            (item.kind === "campaign"
                              ? "digitalCards.stats.contextCampaign"
                              : "digitalCards.stats.contextShare"
                            ) | translate
                          }}
                        </span>
                      </div>
                      <div class="detail-list__bar" aria-hidden="true">
                        <span [style.width.%]="item.pct"></span>
                      </div>
                      <span class="detail-list__count">
                        <strong>{{ item.count | number }}</strong>
                        <small>{{ item.pct }}%</small>
                        <small *ngIf="row.visits" class="detail-list__of-visits">
                          {{ item.ofVisitsPct }}%
                          {{ "digitalCards.stats.ofVisits" | translate }}
                        </small>
                      </span>
                    </li>
                  </ul>
                </section>

                <section class="detail-panel">
                  <header class="detail-panel__header">
                    <h3>{{ "digitalCards.stats.clicksTitle" | translate }}</h3>
                    <span class="detail-panel__total">{{
                      row.interactionsTotal | number
                    }}</span>
                  </header>
                  <p class="detail-panel__empty" *ngIf="!row.clickBreakdown.length">
                    {{ "digitalCards.stats.noClicks" | translate }}
                  </p>
                  <ul class="detail-list" *ngIf="row.clickBreakdown.length">
                    <li *ngFor="let item of row.clickBreakdown">
                      <div class="detail-list__meta">
                        <span class="detail-list__label">{{ item.label }}</span>
                        <span class="detail-list__kind">{{
                          "digitalCards.stats.contextClick" | translate
                        }}</span>
                      </div>
                      <div class="detail-list__bar" aria-hidden="true">
                        <span [style.width.%]="item.pct"></span>
                      </div>
                      <span class="detail-list__count">
                        <strong>{{ item.count | number }}</strong>
                        <small>{{ item.pct }}%</small>
                        <small *ngIf="row.visits" class="detail-list__of-visits">
                          {{ item.ofVisitsPct }}%
                          {{ "digitalCards.stats.ofVisits" | translate }}
                        </small>
                      </span>
                    </li>
                  </ul>
                </section>
              </div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="stats-data-row"
          [class.stats-data-row--expanded]="row.isExpanded"
          [class.stats-data-row--clickable]="row.hasDetails"
          (click)="toggleRow(row)"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: detailColumns"
          class="expanded-row"
          [class.expanded-row--open]="row.isExpanded"
        ></tr>
      </table>

      <div class="loading-wrapper" *ngIf="tableLoading">
        <app-loading></app-loading>
      </div>

      <div class="empty-state" *ngIf="!tableLoading && isEmpty">
        <mat-icon class="empty-state__icon">bar_chart</mat-icon>
        <p>{{ "auditLog.noData" | translate }}</p>
      </div>

      <div class="empty-state" *ngIf="showNoSearchResults">
        <mat-icon class="empty-state__icon">search_off</mat-icon>
        <p>{{ "auditLog.noData" | translate }}</p>
      </div>
    </div>

    <mat-paginator
      *ngIf="totalRows > 0"
      [length]="totalRows"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      (page)="onPage($event)"
    ></mat-paginator>
  </div>
</div>
